import React, { Component } from "react";
import { connect } from "react-redux";
import M from "materialize-css/dist/js/materialize.min.js";
import $ from "jquery";
import { Link } from "react-router-dom";
import noUiSlider from "nouislider";
import { updateConnection,stopConnection,setLoading } from "../../actions/ui/settings";
import { settings,colors } from "../../config.js";
import Modal from "../helper/modal";
import callBC from "../../actions/helpers/bc";
import isElectron from 'is-electron';
import './wifi.css';
const ipcRenderer = window.ipcRenderer;

class SideStatus extends Component {
  state = {...this.props.settings,searching:false,allowManual:false,view:'automatic'};
  openModal() {
    let _this = this;
    if (document.querySelectorAll("#modalSettings2")[0]) {
      var instance = M.Modal.getInstance(document.querySelectorAll("#modalSettings2")[0]);
      if (instance) {
        instance.open();
        var elem = document.querySelectorAll('.sidenav');
        instance = M.Sidenav.getInstance(elem[0]);
        instance.close()
      }
      if(_this.props.settings.manualConnect){
        setTimeout(() => {
          _this.props.networksettings.forEach(({ id }) => {
            $(`#${id}`)[0].value = _this.state[id];
          });
        }, 100);
      }
    }
  }
  render() {
    return (
      <li>
        <a style={{cursor:'pointer'}} onClick={this.openModal.bind(this)}>
          <i
            style={{color:this.props.socket.connected ? colors.green : colors.red}}
            className="material-icons icon"
          >
            {this.props.socket.connected ? 'wifi' : 'wifi_off'}
          </i>
          {this.props.text ? 'Connection' : null}
        </a>
      </li>
    );
  }
}

function mapStateToProps(state, props) {
  let networksettings = [
    {
      title: "Miner URL",
      id: "hostname",
      width: "100%",
      placeholder:'http://localhost'
      // background: "#80808030"
    },
    { title: "Miner Port", id: "port", width: "100%",placeholder:'Optional' },
    {
      title: "Miner Secure Cookie",
      id: "scookie",
      width: "100%",
      placeholder:'Optional'
      // background: "#80808030"
    }
  ];

  return {
    socket: state.socket,
    settings: state.settings.settings,
    networksettings
  };
}

// <div className='col s12 center' style={{marginTop:'20px'}}>
  {/*!this.props.socket.no_rpc && !this.state.searching && this.props.settings.manualConnect && !this.state.allowManual && this.check()*/}
// </div>

export default connect(
  mapStateToProps,
  {
    updateConnection,
    stopConnection,
    setLoading
  }
)(SideStatus);
